module.exports = __webpack_public_path__ + "static/media/Infografia ALA.d8084dac.png";